import { render, staticRenderFns } from "./AssignmentActions.vue?vue&type=template&id=63f5810e&scoped=true&"
import script from "./AssignmentActions.vue?vue&type=script&lang=js&"
export * from "./AssignmentActions.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentActions.vue?vue&type=style&index=0&id=63f5810e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f5810e",
  null
  
)

export default component.exports